module.exports = __webpack_public_path__ + "img/suitcase.0200becb.png";